var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pageNotFound"},[_c('div',{staticClass:"inner"},[_c('h1',[_vm._v("404")]),_c('p',[_vm._v("Page not found. Back to home page")]),_c('p',[_c('el-button',{attrs:{"type":"primary"}},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Back to home")])],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }